// extracted by mini-css-extract-plugin
export default {"root":"UserInfo_root__QovtM","date":"UserInfo_date__jOf7i","month":"UserInfo_month__pguJe"};